let state = {
  quickLinks:[]
}
export default state



// WEBPACK FOOTER //
// ./src/store/quickLinks/state.js